import React, { useEffect, useState } from 'react';

import { newsDateString } from '../../helpers/dates';
import { OccationNewsCard } from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import { CardLogo } from './card-logo';
import Link from 'next/link';

interface CardNewsItemProps {
  card: OccationNewsCard;
  cardIndex: number;
}

export const CardNewsItem = ({ card, cardIndex }: CardNewsItemProps) => {
  const [isDateVisible, setIsDateVisible] = useState<boolean>(true);

  useEffect(() => {
    if (card?.isdatevisible == false) setIsDateVisible(false);
  }, [isDateVisible]);
  return (
    <>
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group relative flex aspect-0.75/1 cursor-pointer flex-col overflow-hidden rounded-xl focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light`}
      >
        {card?.image?.url && (
          <ImageWrapper
            url={card?.image?.url}
            alt={
              card?.image?.description
                ? card?.image?.description
                : 'alt text not found'
            }
            className="!absolute inset-0  aspect-0.75/1 transition-all"
            imgClassName="object-cover block w-full"
            width={card?.image?.width ? parseInt(card.image.width) : undefined}
            height={
              card?.image?.height ? parseInt(card.image.height) : undefined
            }
          />
        )}

        <div className="relative flex h-full flex-col justify-end bg-gradient-to-t from-transparency-overlay-solid px-6 py-4 transition-all duration-200 ease-in-out lg:group-hover:bg-transparency-backdrop ">
          <CardLogo card={card} />
          <h2 className="mb-2 font-title text-headingm text-brand-white transition-all duration-200 ease-in-out lg:group-hover:text-brand-yellow-1">
            {card?.name}
          </h2>

          <div className="mb-4 text-bodym text-brand-white">
            {/* {isDateVisible && ( */}
            {isDateVisible &&
              newsDateString(card?.date?.toString(), card?.node_locale)}
          </div>
        </div>
      </Link>
    </>
  );
};
